function printDataValues(block, dataValues) {
  const formatNumber = (num) => new Intl.NumberFormat().format(num);
  const formatMoneyShort = (number) => {
    if (number >= 1_000_000_000) {
      return `<strong>$${(number / 1_000_000_000).toFixed(1)}</strong> billion`;
    } else if (number >= 1_000) {
      return `<strong>$${(number / 1_000_000).toFixed(1)}</strong> million`;
    } else {
      return `<strong>$${number}</strong>`;
    }
  };

  // Loop through dataValues and log each value
  dataValues.forEach((value, index) => {
    if (index > 0) {
      const spanElement = block.querySelector(
        `.data-item-${index} span.data-value`
      );
      if (spanElement) {
        spanElement.innerHTML =
          spanElement.getAttribute("data-format-as-currency") === "On"
            ? formatMoneyShort(value)
            : formatNumber(value);
      }
    }
  });
}

export function initAreasProgressData(context) {
  once("areasProgessData", ".areas-progress-data-block", context).forEach(
    (block) => {
      block
        .querySelectorAll(".areas-progress-data-select")
        .forEach((select) => {
          const dataValues = JSON.parse(
            select.options[0].getAttribute("data-values")
          );
          printDataValues(block, dataValues);

          select.addEventListener("change", function () {
            const dataValues = JSON.parse(
              select.options[select.selectedIndex].getAttribute("data-values")
            );
            printDataValues(block, dataValues);
          });
        });
    }
  );
}
